import Vue from "vue";
import DataWebConfig from "@Scripts/Config/DataWebConfig";
import AppConfig from "@Scripts/Config/AppConfig";
import { router } from "@Scripts/Config/RouteConfig";
import { store } from "@Scripts/Config/StoreConfig";
import Localizer from "@Scripts/Common/Localizer";

export default class BasePage {
    public static async init() {
        await Localizer.init({
            defaultCulture: (<any>window).App.culture,
            resourceContexts: ["App", "Account", "Newsletter", "CookieToast"]
        });

        let DataWeb = (<any>window).DataWeb;
        if (DataWeb) {
            Vue.use(DataWeb.default);
            Vue.use(DataWebConfig);

            await DataWeb.Localizer.init({ defaultCulture: (<any>window).App.userCulture, resourceContexts: ["DataWeb", "Account"] });
        }

        AppConfig.AddComponents();

        let vm = new Vue({
            el: "#app",
            router,
            store,
            created() {
                if (DataWeb) {
                    DataWeb.default.registerRoutes(router);
                    DataWeb.default.registerStoreModules(store);
                }
            }
        });

        (<any>window).App.instances.vm = vm;

        this.resetCssAnimations();
        this.setCarousel();
        this.setFancybox();
        this.setCredits();
        this.setTopMenu();
        this.setWrapSideMenu();
        this.inputFileUpload();
    }

    private static resetCssAnimations() {
        (<any>window).addEventListener("load", function () {
            let loaders = document.getElementsByClassName("loader");
            for (let i = 0; i < loaders.length; i++) {
                loaders[i].classList.add("hide");
            }

            let preLoaders = document.querySelectorAll("[data-preload]");
            for (let i = 0; i < preLoaders.length; i++) {
                preLoaders[i].removeAttribute("data-preload");
            }
        });
    }

    private static setFancybox() {
        const btnHtmlClose = "<div title=\"Close\" class=\"mpopup-btn\" data-type=\"close\"><span class=\"fa fa-times\"></span></div>";

        (<any>$(".fncyb")).fancybox({
            padding: [20, 0, 20, 0],
            width: "100%",
            margin: [40, 0, 40, 0],
            closeBtn: true,
            tpl: {
                closeBtn: btnHtmlClose
            },
            scrollOutside: false,
            transitionIn: "fade",
            transitionOut: "fade",
            prevEffect: "fade",
            nextEffect: "fade",
            changeFade: 0
        });

        (<any>$(".fncyb-img")).fancybox({
            padding: [0, 0, 0, 0],
            width: "100%",
            margin: [40, 40, 40, 40],
            scrollOutside: false,
            transitionIn: "fade",
            transitionOut: "fade",
            prevEffect: "fade",
            nextEffect: "fade",
            changeFade: 0
        });

        (<any>$(".fncyb-img-editor")).fancybox({
            padding: [0, 0, 0, 0],
            width: "100%",
            margin: [40, 40, 40, 40],
            scrollOutside: false,
            transitionIn: "fade",
            transitionOut: "fade",
            prevEffect: "fade",
            nextEffect: "fade",
            changeFade: 0,
            type: "image"
        });

        (<any>$(".fncyb-terms")).fancybox({
            padding: [20, 0, 20, 0],
            width: "100%",
            margin: [40, 0, 40, 0],
            closeBtn: true,
            tpl: {
                closeBtn: btnHtmlClose
            },
            scrollOutside: false,
            transitionIn: "fade",
            transitionOut: "fade",
            prevEffect: "fade",
            nextEffect: "fade",
            changeFade: 0,
            afterClose: function () {
                const termsAgreement = <HTMLInputElement>document.getElementById("IsTermsAgreement");
                if (termsAgreement) termsAgreement.checked = true;
            }
        });

    };

    private static setCarousel() {
        // https://stackoverflow.com/a/38914124
        if ($(".carousel>.carousel-item").length > 4) {
            (<any>$(".carousel")).bxSlider({
                slideWidth: 180,
                minSlides: 3,
                maxSlides: 4,
                slideMargin: 10,
                pager: $(".carousel>.carousel-item").length > 4 ? true : false,
                controls: true,
                nextText: '',
                prevText: '',
                infiniteLoop: false,
                hideControlOnEnd: true
            });
        }
    }

    private static setCredits() {
        const credits = document.getElementsByClassName("credits")[0];

        if (credits) {
            credits.addEventListener("mouseenter", () => {
                const label = credits.getElementsByClassName("label")[0];
                const tooltip = credits.getElementsByClassName("tooltip")[0];

                if (label) label.classList.add("label-hover");
                if (tooltip) tooltip.classList.add("show");
            });

            credits.addEventListener("mouseleave", () => {
                const label = credits.getElementsByClassName("label")[0];
                const tooltip = credits.getElementsByClassName("tooltip")[0];

                if (label) label.classList.remove("label-hover");
                if (tooltip) tooltip.classList.remove("show");
            });
        }
    }

    private static setTopMenu() {
        const buttons = document.getElementsByClassName("button-menu");
        const wrapButtons = document.getElementsByClassName("wrapmenu-button");
        const items = document.getElementsByClassName("item");

        for (let i = 0; i < buttons.length; i++) {
            const button = buttons[i];
            button.addEventListener("click", function () {
                const itemCurrent = this.parentElement;
                const expCurrent = itemCurrent.getElementsByClassName("exp")[0];

                expCurrent.classList.toggle("show");

                if (expCurrent.classList.contains("show")) {
                    itemCurrent.setAttribute("data-selected", "true");
                    const mainMenu = document.querySelector(".app-header .mainmenu .menu");
                    if (mainMenu) {
                        mainMenu.scrollTo({ top: itemCurrent.getBoundingClientRect().top + mainMenu.scrollTop, behavior: "smooth" });
                    }
                } else {
                    itemCurrent.removeAttribute("data-selected");
                }

                for (let i = 0; i < items.length; i++) {
                    const item = items[i];
                    if (item !== itemCurrent) {
                        item.setAttribute("data-selected", "");
                        const otherExp = item.getElementsByClassName("exp")[0];
                        if (otherExp) {
                            otherExp.classList.remove("show");
                        }
                    }
                }
            });
        }

        for (let i = 0; i < wrapButtons.length; i++) {
            const wrapButton = wrapButtons[i];
            wrapButton.addEventListener("click", function () {
                const wrapMenuTap = document.getElementsByClassName("wrapmenu-tap")[0];
                const menu = document.getElementsByClassName("menu")[0];
                wrapMenuTap.classList.toggle("show");

                if (menu.classList.contains("anim-wrapmenu-open")) {
                    menu.classList.remove("anim-wrapmenu-open");
                    menu.classList.add("anim-wrapmenu-close");
                } else {
                    menu.classList.remove("anim-wrapmenu-close");
                    menu.classList.add("anim-wrapmenu-open");
                }
            });
        }
    }

    private static setWrapSideMenu() {
        const wrapSideMenuButton = document.getElementsByClassName("wrapsidemenu-button")[0];
        const sideMenu = document.getElementsByClassName("sidemenu")[0];

        if (wrapSideMenuButton && sideMenu) {
            wrapSideMenuButton.addEventListener("click", () => {
                sideMenu.classList.toggle("show");
            });
        }
    }

    private static inputFileUpload = () => {
        $(".file-upload-button").on("click", () => {
            $(".file-upload-input").trigger("click");
        });

        $(".file-upload-input").on("change", function (this: HTMLInputElement) {
            if (this.files && this.files[0]) {
                const fileName = this.files[0].name;
                const fileSize = (this.files[0].size / 1024).toFixed(2);
                $(".file-upload-label").show().html(`${fileName} (${fileSize} kB)`);
            }
        });
    };
};